import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTE } from '@core/models/route';
import { Error403Component } from './pages/error/error403/error403.component';
import { LoggedOutComponent } from './pages/loggedout/loggedout.component';
import { CombinedGuard } from '@anb/ng-core';
import { AnbBrowserSupportedGuard } from '@anb/ng-ui';
import { AnbAuthGuard } from '@anb/ng-auth';
import { AM_BO_BD_R, AM_BO_BVA_R, AM_BO_CWBE_R, AM_BO_R_R } from '@core/models/taskpermissions';

const appRoutes: Routes = [
  {
    path: ROUTE.LOGGEDOUT,
    component: LoggedOutComponent,
  },
  {
    path: ROUTE.FORBIDDEN,
    component: Error403Component,
  },
  {
    path: ROUTE.HOME,
    loadChildren: () => import('./modules/afschotmelding/afschotmelding.module').then((mod) => mod.AfschotmeldingModule),
    canActivate: [CombinedGuard],
    data: {
      guards: [AnbBrowserSupportedGuard, AnbAuthGuard],
      taskPermissions: [AM_BO_CWBE_R, AM_BO_R_R, AM_BO_BVA_R, AM_BO_BD_R],
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
